<template>
  <ul class="nav nav-mobile-menu">
<!--    <li>-->
<!--      <md-field>-->
<!--        <label>Search</label>-->
<!--        <md-input v-model="search" type="text"></md-input>-->
<!--      </md-field>-->
<!--    </li>-->
<!--    <li>-->
<!--      <a @click="linkDashboard" class="dropdown-toggle" data-toggle="dropdown">-->
<!--        <i class="material-icons">dashboard</i>-->
<!--        <p>Dashboard</p></a-->
<!--      >-->
<!--    </li>-->
<!--    <li>-->
<!--      <drop-down>-->
<!--        <a slot="title" class="dropdown-toggle" data-toggle="dropdown" @click="getNotifications">-->
<!--          <i class="material-icons">notifications</i>-->
<!--          <span-->
<!--            class="notification"-->
<!--            style="font-size: 13px;font-weight: bold;"-->
<!--            v-if="notification_count !== 0"-->
<!--            >{{ notification_count }}</span-->
<!--          >-->
<!--          <p>Notifications</p>-->
<!--        </a>-->
<!--        <ul class="dropdown-menu dropdown-menu-right">-->
<!--          <li-->
<!--            v-for="n in notifications"-->
<!--            v-bind:key="n.id"-->
<!--            :value="n.id"-->
<!--          >-->
<!--            <a-->
<!--              :href="-->
<!--                '/application/update/' + n.relation.application_id-->
<!--              "-->
<!--              >{{ n.content }}</a-->
<!--            >-->
<!--          </li>-->
<!--        </ul>-->
<!--      </drop-down>-->
<!--    </li>-->
    <li>
      <a @click="linkAccount" data-toggle="dropdown" class="dropdown-toggle"
        ><i class="material-icons">person</i>
        <p>Account</p></a
      >
    </li>
    <li>
      <a @click="logout"
        ><i class="material-icons">login</i>
        <p>Logout</p></a
      >
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      notification_count: 0,
      notifications: [],
      // search: null,
      // selectedEmployee: null,
      // employees: [
      //   "Jim Halpert",
      //   "Dwight Schrute",
      //   "Michael Scott",
      //   "Pam Beesly",
      //   "Angela Martin",
      //   "Kelly Kapoor",
      //   "Ryan Howard",
      //   "Kevin Malone"
      // ]
    };
  },
  methods: {
    linkDashboard() {
      this.$router.push({ name: "Dashboard" });
    },
    linkAccount() {
      this.$router.push({ name: "User Page" });
    },
    getNotificationCount() {
      this.$store
        .getNotificationCount()
        .then(response => {
          this.notification_count = response.data.count;
        })
        .catch(error => {
          var message = error.message;
          this.$notify({
            message: message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
      var cs = this;
      setTimeout(function() {
        if (cs.loop_count < cs.loop_limit) {
          cs.loop_count++;
          cs.getNotificationCount();
        }
      }, 120000);
    },
    getNotifications() {
      this.$store
        .getNotifications()
        .then(response => {
          this.notifications = response.data.results;
          this.notification_count = 0;
        })
        .catch(error => {
          var message = error.message;
          this.$notify({
            message: message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    logout() {
      this.$store
        .logout()
        .then(response => {
          this.$router.push({ name: "Login" });
        })
        .catch(error => {
          var message = error.message;
          this.$notify({
            message: message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    }
  }
};
</script>
